<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><ellipse cx="16" cy="13" rx="1" ry=".75"/><path d="M27.5 22.61v-8.24h.05a1.5 1.5 0 000-2.68L16.89 6.33a2 2 0 00-1.78 0L4.45 11.66a1.5 1.5 0 000 2.68L7 15.62V21c0 2.66 4.21 5 9 5s9-2.34 9-5v-5.38l1.5-.75v7.74a1.25 1.25 0 101 0zM23 21c0 1-2.73 3-7 3s-7-2-7-3v-4.38l6.11 3.05a2 2 0 001.78 0L23 16.62zm-7-3.12L6.24 13 16 8.12 25.76 13z"/></svg>